export const janinaMalkowska = {
    'meta': {
        'title': 'Psychiatra dzieci i młodzieży Janina Małkowska • COLLIGO',
        'description': 'Lekarz specjalista psychiatrii dzieci i młodzieży. Prowadzi konsultacje psychiatryczne dzieci i młodzieży.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psychiatra-dzieci-i-mlodziezy-janina-malkowska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/janina-malkowska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra dzieci i młodzieży Janina Małkowska'
        }
    }
}